// redux/ai/aiActions.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { sendAiChatApi, fetchAiStatusApi, fetchAiRecentApi } from "./aiApi";
import { showApiErrorToast } from "../../utils/toastErrorHandler";

export const sendAiMessage = createAsyncThunk(
  "ai/sendMessage",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await sendAiChatApi(payload);
      // backend shape: { success, data: { reply, provider, model, ... }, message }
      return res?.data?.data;
    } catch (err) {
      const msg =
        err?.response?.data?.message || err?.message || "AI request failed";
      // Do NOT log the user out on an AI failure (unlike data thunks).
      showApiErrorToast(msg);
      return rejectWithValue(msg);
    }
  },
);

export const fetchAiStatus = createAsyncThunk(
  "ai/fetchStatus",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetchAiStatusApi();
      return res?.data?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message);
    }
  },
);

export const fetchAiRecent = createAsyncThunk(
  "ai/fetchRecent",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetchAiRecentApi();
      return res?.data?.data?.recent || [];
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message);
    }
  },
);
